"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = void 0;
const styles_1 = require("@mui/material/styles");
exports.Root = (0, styles_1.styled)("span")({
    display: "block",
    textIndent: "-9999px",
    overflow: "hidden",
    position: "absolute"
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FsdGVybmF0aXZlLWNvbnRlbnQvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGlEQUE4QztBQUVqQyxRQUFBLElBQUksR0FBRyxJQUFBLGVBQU0sRUFBQyxNQUFNLENBQUMsQ0FBQztJQUNqQyxPQUFPLEVBQUUsT0FBTztJQUNoQixVQUFVLEVBQUUsU0FBUztJQUNyQixRQUFRLEVBQUUsUUFBUTtJQUNsQixRQUFRLEVBQUUsVUFBVTtDQUNyQixDQUFDLENBQUMifQ==